import React from "react"
import Fade from "react-reveal/Fade"
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import TextInfoContent from '@mui-treasury/components/content/textInfo';
import { useBlogTextInfoContentStyles } from '@mui-treasury/styles/textInfoContent/blog';

const Research = () => {

  const styles = useBlogTextInfoContentStyles();
  return (
    <div className="section" id="research">
      <div className="container">
        <div className="research-container">
          <Fade bottom cascade>
            <h1>Research</h1>
          </Fade>

          <Fade bottom cascade>
            <div className="research-grid">
              <div className="research" key={1}>
                <Box maxWidth={750}>
                  <CardContent>
                    <TextInfoContent
                      useStyles={useBlogTextInfoContentStyles}
                      overline={'15 NOV 2021'}
                      heading={'CaptureIt! - A Web-based Attendance System Using Face Recognition'}
                    />
                    <Button href="https://ieeexplore.ieee.org/document/9597350" className={styles.button}>See Publication</Button>
                  </CardContent>
                </Box>
              </div>

              <div className="research" key={2}>
                <Box maxWidth={750}>
                  <CardContent>
                    <TextInfoContent
                      useStyles={useBlogTextInfoContentStyles}
                      overline={'23 JUNE 2022'}
                      heading={'CoviFacts - A Covid-19 Fake News Detector Using Natural Language Processing.'}
                    />
                    <Button href="https://link.springer.com/chapter/10.1007/978-981-19-0095-2_50" className={styles.button}>See Publication</Button>
                  </CardContent>
                </Box>
              </div>
            </div>
          </Fade>

        </div>
      </div>
    </div>
  )
}

export default Research
